import React from "react";
import { Link } from "react-router-dom";
import './Footer.css';

import Logo from '../../img/logoV2.png';
import Facebook from '../../img/FacebookSoc.png';
import Twitter from '../../img/Twitter.png';
import Instagram from '../../img/Instagram.png';
import Tiktok from '../../img/Tiktok.png';
import Whatsapp from '../../img/Whatsapp.png';

const NAV_COLUMNS = [
    {
        title: 'Compañía',
        links: [
            { to: '/about', label: 'Acerca de nosotros' },
        ],
    },
    {
        title: 'Explorar',
        links: [
            { to: '/faqs', label: 'Cómo funciona' },
            { to: '/', label: 'Almacenes' },
            { to: '/faqs#cliente', label: 'Tipos de almacenaje' },
        ],
    },
    {
        title: 'Anfitriones',
        links: [
            { to: '/unirte', label: 'Listar tu almacén' },
            { to: '/faqs#anfitrion', label: 'Responsabilidades' },
            { to: '/faqs#anfitrion', label: 'Recursos' },
        ],
    },
    {
        title: 'Legal',
        links: [
            { href: 'http://file.palletcloud.io/TERMINOS.pdf', label: 'Términos' },
            { href: 'http://file.palletcloud.io/PRIVACIDAD.pdf', label: 'Privacidad' },
            { href: 'http://file.palletcloud.io/CONSENTIMIENTO.pdf', label: 'Datos personales' },
        ],
    },
    {
        title: 'Ayuda',
        links: [
            { to: '/faqs#contacto', label: 'Atención al cliente' },
            { to: '/faqs', label: 'FAQs' },
        ],
    },
];

const SOCIAL = [
    { href: 'https://www.facebook.com/profile.php?id=61580626684046', icon: Facebook, label: 'Facebook' },
    { href: 'https://x.com/palletcloud', icon: Twitter, label: 'X' },
    { href: 'https://www.instagram.com/palletcloud/', icon: Instagram, label: 'Instagram' },
    { href: 'https://www.tiktok.com/@palletcloud', icon: Tiktok, label: 'TikTok' },
    { href: 'https://wa.me/', icon: Whatsapp, label: 'WhatsApp' },
];

const NavLink = ({ link }) => {
    if (link.href) {
        return (
            <a href={link.href} target="_blank" rel="noopener noreferrer">
                {link.label}
            </a>
        );
    }
    return <Link to={link.to}>{link.label}</Link>;
};

const Footer = () => {
    const year = new Date().getFullYear();

    return (
        <footer className="ft">
            <div className="ft__inner">
                <div className="ft__main">
                    <div className="ft__brand">
                        <Link to="/" className="ft__logo" aria-label="Ir al inicio de PalletCloud">
                            <img src={Logo} alt="PalletCloud" />
                        </Link>
                        <p className="ft__tagline">
                            Renta de almacenes industriales en México — simple, digital y confiable.
                        </p>
                        <div className="ft__actions">
                            <Link to="/unirte" className="ft__cta">Publica tu almacén</Link>
                        </div>
                        <div className="ft__social" aria-label="Redes sociales">
                            <span className="ft__social-label">Síguenos</span>
                            <div className="ft__social-icons">
                                {SOCIAL.map((s) => (
                                    <a
                                        key={s.label}
                                        href={s.href}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        aria-label={s.label}
                                    >
                                        <img src={s.icon} alt="" />
                                    </a>
                                ))}
                            </div>
                        </div>
                    </div>

                    <nav className="ft__nav" aria-label="Enlaces del sitio">
                        {NAV_COLUMNS.map((col) => (
                            <div className="ft__col" key={col.title}>
                                <h3>{col.title}</h3>
                                <ul>
                                    {col.links.map((link) => (
                                        <li key={link.label}>
                                            <NavLink link={link} />
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                    </nav>
                </div>

                <div className="ft__bar">
                    <p className="ft__copy">© {year} PalletCloud, Inc.</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
